"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../utils/index");

var _Header = _interopRequireDefault(require("../Header/Header"));

var _applePayLogo = _interopRequireDefault(require("../../assets/images/apple-pay-logo.png"));

var _googlePayLogo = _interopRequireDefault(require("../../assets/images/google-pay-logo.png"));

var _paymentIconAmex = _interopRequireDefault(require("../../assets/images/payment-icon-amex.png"));

var _paymentIconMastercard = _interopRequireDefault(require("../../assets/images/payment-icon-mastercard.png"));

var _poweredByStripe = _interopRequireDefault(require("../../assets/images/powered-by-stripe.png"));

var _paymentIconVisa = _interopRequireDefault(require("../../assets/images/payment-icon-visa.png"));

var _index2 = require("../../types/index");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PageDefinition = _flowRuntime["default"].tdz(function () {
  return _index2.PageDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("amountValue", _flowRuntime["default"].number()), _flowRuntime["default"].property("formPage", _flowRuntime["default"].ref(PageDefinition)), _flowRuntime["default"].property("giftaidValue", _flowRuntime["default"].string())));

var _default = function _default(_arg) {
  var amountValue = _arg.amountValue,
      formPage = _arg.formPage,
      giftaidValue = _arg.giftaidValue;
  return /*#__PURE__*/React.createElement("div", {
    className: "group row"
  }, formPage.header && /*#__PURE__*/React.createElement("div", {
    className: "col span_6_of_12"
  }, /*#__PURE__*/React.createElement(_Header["default"], {
    key: formPage.key,
    header: formPage.header
  }), amountValue && /*#__PURE__*/React.createElement("h3", null, "You are donating ", /*#__PURE__*/React.createElement("strong", null, "\xA3", (amountValue / 100).toFixed(2), " "), giftaidValue && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, "(".concat((0, _index.giftAidAmount)(amountValue, giftaidValue), " with Gift Aid)"))))), /*#__PURE__*/React.createElement("div", {
    className: "col span_6_of_12 payment-icons"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, "We accept the following payment methods")), /*#__PURE__*/React.createElement("img", {
    src: _paymentIconVisa["default"],
    alt: "Visa"
  }), /*#__PURE__*/React.createElement("img", {
    src: _paymentIconMastercard["default"],
    alt: "Mastercard"
  }), /*#__PURE__*/React.createElement("img", {
    src: _paymentIconAmex["default"],
    alt: "American Express"
  }), /*#__PURE__*/React.createElement("img", {
    src: _applePayLogo["default"],
    alt: "Apple Pay",
    style: {
      margin: '0 10px'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: _googlePayLogo["default"],
    alt: "Google Pay",
    style: {
      margin: '0 10px'
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: _poweredByStripe["default"],
    alt: "Powered by Stripe"
  })));
};

exports["default"] = _default;